import GoogleMapReact from "google-map-react"
import mapStyles from "@/common/map/styles"
import styles from "./calendar-single.module.css"

export default function EventMap({ object }) {
  const { lat, lng } = object.coordinates

  if (!lat || !lng) {
    return null
  }

  const link =
    "https://www.google.com/maps/search/?api=1&query=" + lat + "," + lng

  const mapKey = process.env.NEXT_PUBLIC_GOOGLE_MAP_KEY

  return (
    <>
      <div className={styles.map}>
        <div className="inner-wrapper">
          <GoogleMapReact
            className="relative"
            bootstrapURLKeys={{
              key: mapKey,
              region: "SE",
              language: "sv"
            }}
            center={{ lng: lng, lat: lat }}
            zoom={9}
            options={{
              styles: mapStyles,
              fullscreenControl: false,
              disableDoubleClickZoom: true,
              zoomControl: true,
              disableDefaultUI: true
            }}
            yesIWantToUseGoogleMapApiInternals={true}
            disableDoubleClickZoom={true}>
            <Marker lng={lng} lat={lat} />
          </GoogleMapReact>
        </div>
      </div>
      <a href={link} target="_blank" rel="noreferrer">
        Visa plats på Google Maps
      </a>
    </>
  )
}

const Marker = () => {
  return <div className="marker"></div>
}
